// @flow

import type { State } from "@store/reducers";
import type {
  EventsPageState,
  ClassificationsPageState,
  PromptsPageState,
} from "@modules/service/reducer/pages/types";

export const isLoading = (state: State): boolean => !!(state.service.pages.requestsInProgress > 0);

export const getEventsCount = (state: State): EventsPageState => state.service.pages.eventsPage;

export const getClassificationsCount = (state: State): ClassificationsPageState =>
  state.service.pages.classificationsPage;

export const getPromptsCount = (state: State): PromptsPageState => state.service.pages.promptsPage;
